export const RichTextValidation = content => {
    if (content && content.value && content.value !== '<p><br></p>' || content && content.value && content.value !== '<h3><br></h3>' ) return true;

    return false;
};

export default {
    RichTextValidation,
};
